import React from 'react'
import {connect} from 'react-redux'
import {Field} from 'redux-form';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import moment from 'moment'
import ReactTooltip from 'react-tooltip';
import 'moment/locale/pt-br'
import '../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import buscarViagens from '../../actions/viagem/buscarViagens';
import alterarViagemSelecionada from '../../actions/viagem/alterarViagemSelecionada';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarOrigem from '../../actions/origem/selecionarOrigem'
import selecionarDataVolta from '../../actions/destino/selecionarDataVolta'
import selecionarDestino from '../../actions/destino/selecionarDestino'
import selecionarUsuario from '../../actions/usuario/selecionarUsuario'
import limparViagens from '../../actions/viagem/limpaViagens';
import Autorizacao from '../../security/Autorizacao';
import {getOperadorEmpresa, getPerfisVendedores, PERFIL_ADMIN, getAdminEmpresa, getUsuarioHabilitadoVendaOffline} from '../../security/securityContext';
import {renderField} from '../../util/arraysUtil';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import limparDataVolta from '../../actions/destino/limparDataVolta';
import AbaSelecionarEMarcarPoltrona from './AbaSelecionarEMarcarPoltrona';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import selecionarViagemVolta from '../../actions/viagem/selecionarViagemVolta';
import limparMapaVeiculoItinerarioIda from '../../actions/mapa-veiculo/limparMapaVeiculoItinerarioIda';
import limparMapaVeiculoItinerarioVolta from '../../actions/mapa-veiculo/limparMapaVeiculoItinerarioVolta';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import {showErrorMsg} from '../../util/messagesUtil';
import SelecaoUsuarioEmpresaAutoComplete from '../layout/SelecaoUsuarioEmpresaAutoComplete';
import { campoBuscaTipoVeiculo } from '../../util/constantsUtil';
import ImageGrid from '../veiculo/ImageGrid';
import Modal from '../veiculo/Modal';

registerLocale('pt', pt);
setDefaultLocale('pt');

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col">Saida</div>
      <div className="col">Embarque</div>
      <div className="col">Livres</div>
        <div className="col">Prestador</div>
      <div className="col">Categoria</div>
      <div className="col">Veículo</div>
      <div className="col">Valor</div>
      <div className="col">Rota</div>
      <div className="col">Empresa</div>
    </div>
  </div>
);


export class AbaItinerario extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: '',
      paginaSelecionada: 1,
      sugestoes: [],
      buscaNaEmpresaSelecionada: true,
      vendaDirecionada: false,
      buscaTipoVeiculo: campoBuscaTipoVeiculo.TODOS.chave,
      selectedImg: null,
    };
    this.selecionarDestino = this.selecionarDestino.bind(this);
    this.selecionarOrigem = this.selecionarOrigem.bind(this);
    this.selecionarUsuario = this.selecionarUsuario.bind(this);
  }

  componentDidMount () {
    this.props.selecionarViagemIda();
    this.props.selecionarViagemVolta();
    this.props.limparMapaVeiculoItinerarioIda();
    this.props.limparMapaVeiculoItinerarioVolta();
    this.props.adicionarFormasPagamento(null);
    this.props.adicionarDadosComprador(null);
    this.props.limparViagens();
    this.props.selecionarUsuario(null);
  }

  selecionarDestino (destino) {
    this.props.selecionarDestino(destino);
  }

  selecionarOrigem (origem) {
    this.props.selecionarOrigem(origem);
  }

  selecionarUsuario(usuario) {
    this.props.selecionarUsuario(usuario);
  }

  exibirIconeTaxaEmbarque (viagem) {
    if (viagem && (viagem.taxaEmbarque || viagem.pedagio || viagem.valorAcrescimoMaximoPassagem)) {
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`taxa-embarque-${viagem.idItinerario}_${viagem.tipoVeiculo}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe263;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`taxa-embarque-${viagem.idItinerario}_${viagem.tipoVeiculo}`}
                                type="dark" effect="solid">
                    <div className="row">
                      Valor Passagem: {Number(viagem.preco).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                      <br /> Taxa de embarque: {Number(viagem.taxaEmbarque)
                      .toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}<br/> Total de pedágio: {Number(viagem.pedagio).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}<br/> {viagem.acrescimoMaximoPassagem && Number(viagem.acrescimoMaximoPassagem) > 0 && viagem.valorAcrescimoMaximoPassagem && <>
                       Valor Máximo Passagem: {Number(viagem.valorAcrescimoMaximoPassagem).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}<br/>Percentual Máximo: {Number(viagem.acrescimoMaximoPassagem).toLocaleString('pt-br')}%
                    </>}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  exibirIconeEmpresa (nomeEmpresa) {
    if (nomeEmpresa) {
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`nome-empresa-${nomeEmpresa}`}>
                  {nomeEmpresa}
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`nome-empresa-${nomeEmpresa}`}
                                type="dark" effect="solid">
                    <div className="row">{nomeEmpresa}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  selecionarPoltronas () {
    let ida = [];
    let volta = [];
    if (this.props.viagens.passagensRetorno.length > 0) {
      volta = this.props.viagens.passagensRetorno.filter(f => f.selecionada)
    }
    if (this.props.viagens.passagensIda.length > 0) {
      ida = this.props.viagens.passagensIda.filter(f => f.selecionada)
    }
    const viagem = {
      ida: ida[0],
      volta: volta.length > 0 ? volta[0] : null
    };

    this.props.selecionarViagem(viagem);
    this.setState({ paginaSelecionada: 2 })
  }

  alterarEmpresa (viagem) {
    if (this.props.empresaSelecionada.id !== viagem.idEmpresa) {
      const empresa = this.props.empresas.filter(empresa => empresa.id === viagem.idEmpresa)[0];
      this.props.alterarEmpresaSelecionada(empresa);
    }
  }

  selecionarViagem (viagem) {
    if (viagem.sentido === 'IDA') {
      if (this.props.viagemVolta && this.props.viagemVolta.idEmpresa !== viagem.idEmpresa) {
        showErrorMsg('Selecione passagens na mesma empresa.');
        return
      }
      this.alterarEmpresa(viagem);
      this.props.selecionarViagemIda(viagem);
    }
    if (viagem.sentido === 'VOLTA') {
      if (this.props.viagemIda && this.props.viagemIda.idEmpresa !== viagem.idEmpresa) {
          showErrorMsg('Selecione passagens na mesma empresa.');
        return
      }
      this.alterarEmpresa(viagem);
      this.props.selecionarViagemVolta(viagem);
    }
    this.props.alterarViagemSelecionada(viagem);
  }

  exibirIconeLimparRetorno () {
    if (this.props.dataVolta) {
      return (
        <div>
          <i className="material-icons mt-2" style={{
            marginLeft: '-45px',
            position: 'absolute',
            cursor: 'pointer'
          }} onClick={() => {
            this.props.limparDataVolta();
            this.props.selecionarViagemVolta(null)
          }}>&#xe5cd;</i>
        </div>)
    }
    return '';
  }

  limpaViagens (sentido) {
    if (sentido === 'pesquisaOrigem') {
      this.selecionarOrigem(null)
    }
    if (sentido === 'pesquisaDestino') {
      this.selecionarDestino(null)
    }
    this.props.selecionarViagemVolta(null);
    this.props.selecionarViagemIda(null);
    this.props.limparViagens()
  }

  buscarViagens () {
    this.props.selecionarViagemVolta(null);
    this.props.selecionarViagemIda(null);
    if (this.props.origem || this.props.destino) {
      this.props.buscarViagens(
        this.props.origem.id,
        this.props.destino.id,
        this.props.dataIda,
        this.props.dataVolta,
        this.props.empresaSelecionada.id,
        false,
        this.state.buscaNaEmpresaSelecionada,
        this.state.buscaTipoVeiculo
      )
    }
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg })
  }

  exibirBotaoPesquisarDestinos () {
    return (
      <div className="col-12 col-sm-9 col-md-2">
        <button onClick={() => this.buscarViagens()} style={{ fontSize: 18 }}
                disabled={!this.props.origem || !this.props.destino || !this.props.dataIda}
                className='btn botaoLogar btn-laranja'>Buscar
        </button>
      </div>)
  }

  calcularDuracao (viagem) {
    if (viagem.dataHoraPartida && viagem.dataHoraChegada) {
      const diff = Math.abs(new Date(viagem.dataHoraChegada) - new Date(viagem.dataHoraPartida))
      const h = Math.floor(diff / 3600000)
      const m = Math.floor((diff % 3600000) / 60000)
      return h > 0 ? `${h}h${m > 0 ? m + 'm' : ''}` : `${m}m`
    }
    return ''
  }

  getCompanyInitials (nomeEmpresa) {
    if (!nomeEmpresa) return '?'
    const words = nomeEmpresa.trim().split(/\s+/)
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
    return nomeEmpresa.substring(0, 2).toUpperCase()
  }

  exibirItinerario (passagens, label) {
    if (passagens && passagens.length) {
      if (passagens.length === 1 && passagens[0].selecionada === undefined) {
        this.selecionarViagem(passagens[0])
      }
      return (
        <React.Fragment>
          <div className="vx-trip-section-label">{label}</div>
          <div className="vx-trip-list">
            {passagens
              .sort((a, b) => new Date(a.dataHoraPartida) - new Date(b.dataHoraPartida))
              .map(viagem => {
                const chegada = viagem.dataHoraChegada ? new Date(viagem.dataHoraChegada) : null
                const arrivalTime = chegada
                  ? chegada.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
                  : '--:--'
                const arrivalDate = chegada
                  ? chegada.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }).replace('.', '')
                  : ''
                const duracao = this.calcularDuracao(viagem)
                const initials = this.getCompanyInitials(viagem.nomeEmpresa)
                return (
                  <div
                    key={`${viagem.idItinerario}_${viagem.tipoVeiculo}`}
                    className={`vx-trip-card${viagem.selecionada ? ' vx-trip-card--selected' : ''}`}
                    onClick={() => this.selecionarViagem(viagem)}
                  >
                    {/* Empresa */}
                    <div className="vx-tc-company">
                      <div className="vx-tc-badge">{initials}</div>
                      <div className="vx-tc-company-detail">
                        <span className="vx-tc-company-name">{viagem.nomeEmpresa}</span>
                        <span className="vx-tc-route">{viagem.descRota}</span>
                        {viagem.horarioExtra && (
                          <span className="vx-badge vx-badge-warning">Horário Extra</span>
                        )}
                      </div>
                    </div>

                    {/* Horários */}
                    <div className="vx-tc-times">
                      <div className="vx-tc-time-block">
                        <span className="vx-tc-hour">{viagem.horaPartida}</span>
                        <span className="vx-tc-date">{viagem.dataPartida}</span>
                      </div>
                      <div className="vx-tc-arrow">
                        <div className="vx-tc-arrow-line"></div>
                        {duracao && <span className="vx-tc-duration">{duracao}</span>}
                      </div>
                      <div className="vx-tc-time-block">
                        <span className="vx-tc-hour">{arrivalTime}</span>
                        {arrivalDate && <span className="vx-tc-date">{arrivalDate}</span>}
                      </div>
                    </div>

                    {/* Embarque */}
                    <div className="vx-tc-boarding">
                      <i className="material-icons">place</i>
                      <span
                        data-tip
                        data-for={`embarque-${viagem.idItinerario}_${viagem.tipoVeiculo}`}
                        className="vx-tc-boarding-text"
                      >
                        {viagem.embarque}
                      </span>
                      <ReactTooltip
                        id={`embarque-${viagem.idItinerario}_${viagem.tipoVeiculo}`}
                        type="dark"
                        effect="solid"
                        place="top"
                      >
                        {viagem.embarque}
                      </ReactTooltip>
                    </div>

                    {/* Veículo */}
                    <div className="vx-tc-vehicle">
                      <div className="vx-tc-vehicle-img">
                        <ImageGrid
                          setSelectedImg={this.setSelectedImg.bind(this)}
                          veiculo={viagem.imagemVeiculo}
                          tipoVeiculo={viagem.tipoImagemVeiculo}
                        />
                        {this.state.selectedImg && (
                          <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />
                        )}
                      </div>
                      <div className="vx-tc-vehicle-info">
                        <span className="vx-tc-category">{viagem.descricaoTipoVeiculo}</span>
                        <span className="vx-tc-vehicle-name">{viagem.veiculo}</span>
                        {viagem.nomePrestador && <span className="vx-tc-prestador">{viagem.nomePrestador}</span>}
                      </div>
                    </div>

                    {/* Assentos */}
                    <div className="vx-tc-seats">
                      <i className="material-icons">event_seat</i>
                      <span>{viagem.assentosDisponiveis}</span>
                      <span className="vx-tc-seats-label">livres</span>
                    </div>

                    {/* Preço */}
                    <div className="vx-tc-price">
                      <span className="vx-tc-price-value">
                        {(Number(viagem.preco) + Number(viagem.taxaEmbarque) + Number(viagem.pedagio)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                      </span>
                      {this.exibirIconeTaxaEmbarque(viagem)}
                    </div>

                    {/* Botão selecionar / avançar inline */}
                    {viagem.selecionada && (
                      (viagem.sentido === 'IDA' && !this.props.dataVolta) ||
                      (viagem.sentido === 'VOLTA' && !!this.props.viagemIda)
                    ) ? (
                      <button
                        className="vx-tc-select vx-tc-select--avancar"
                        onClick={e => { e.stopPropagation(); this.props.avancar && this.props.avancar() }}
                      >
                        Avançar
                        <i className="material-icons" style={{ fontSize: 16, verticalAlign: 'middle' }}>arrow_forward</i>
                      </button>
                    ) : (
                      <button
                        className={`vx-tc-select${viagem.selecionada ? ' vx-tc-select--active' : ''}`}
                        onClick={e => { e.stopPropagation(); this.selecionarViagem(viagem) }}
                      >
                        {viagem.selecionada ? 'Selecionado' : 'Selecionar'}
                      </button>
                    )}

                    {/* Rodapé: Itinerário e Rota */}
                    <div className="vx-tc-footer">
                      <span className="vx-tc-footer-item">
                        <span className="vx-tc-footer-label">Itinerário</span>
                        <span className="vx-tc-footer-value">{viagem.idItinerario}</span>
                      </span>
                      <span className="vx-tc-footer-sep">·</span>
                      <span className="vx-tc-footer-item">
                        <span className="vx-tc-footer-label">Rota</span>
                        <span className="vx-tc-footer-value">{viagem.idRota}</span>
                      </span>
                    </div>
                  </div>
                )
              })}
          </div>
        </React.Fragment>
      )
    }
    if ((label === 'IDA' && passagens) || (label === 'VOLTA' && this.props.dataVolta && passagens)) {
      return (
        <React.Fragment>
          <div className="vx-trip-section-label">{label}</div>
          <div className="alert alert-warning text-center" role="alert">
            Não foi encontrado resultado para sua pesquisa.
          </div>
        </React.Fragment>
      )
    }
  }

  selecionarData (data, ida) {
    if (ida) {
      this.props.selecionarDataIda(data);
      this.props.limparDataVolta();
    } else {
      this.props.selecionarDataVolta(data);
    }
  }

  exibirCalendario (ida) {
    let data;

    let minDate = new Date();
    if (ida) {
      if (this.props.dataIda) {
        data = moment(this.props.dataIda)
          .toDate()
      }
    } else {      
      if (this.props.dataVolta) {
        data = moment(this.props.dataVolta)
          .toDate()
      }
    }
    return (
      <div>
        <div className="linha">
          <DatePicker
            className='form-control form-control-lg campo-busca'
            placeholderText={ida ? 'Data Ida' : 'Data Volta'}
            value={data}
            minDate={minDate}
            locale="pt-BR"
            selected={data}
            startDate={moment(this.props.dataIda)
              .toDate()}
            endDate={moment(this.props.dataVolta)
              .toDate()}
            disabled={!ida && !this.props.dataIda}
            onChange={(date) => {
              this.selecionarData(date, ida);
              this.limpaViagens('data')
            }}
            dateFormat="dd/MM/yyyy"
            withPortal
          />
        </div>
      </div>
    )
  }

  exibirCampoBusca () {
    return (
      <div className="vx-search-card">
        <div className="vx-search-grid">
          <div className="vx-search-field">
            <label className="vx-search-label">Origem</label>
            <SelecaoCidadeAutocomplete
              limparViagens={this.limpaViagens.bind(this)}
              name='pesquisaOrigem'
              ehVenda={true}
              placeholder='Cidade origem'
              selecionarCidade={this.selecionarOrigem}
              value={this.props.origem}
            />
          </div>
          <div className="vx-search-field">
            <label className="vx-search-label">Destino</label>
            <SelecaoCidadeAutocomplete
              name='pesquisaDestino'
              ehVenda={true}
              limparViagens={this.limpaViagens.bind(this)}
              placeholder='Cidade destino'
              selecionarCidade={this.selecionarDestino}
              value={this.props.destino}
            />
          </div>
          <div className="vx-search-field">
            <label className="vx-search-label">Data de Ida</label>
            {this.exibirCalendario(true)}
          </div>
          <div className="vx-search-field">
            <label className="vx-search-label">Data de Volta</label>
            <div style={{ position: 'relative' }}>
              {this.exibirCalendario(false)}
              {this.exibirIconeLimparRetorno()}
            </div>
          </div>
          <button
            className="vx-btn-buscar"
            onClick={() => this.buscarViagens()}
            disabled={!this.props.origem || !this.props.destino || !this.props.dataIda}
          >
            <i className="material-icons">search</i>
            Buscar
          </button>
        </div>
        <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12"/>
        <Field name="destino" type="hidden" component={renderField} css="form-control col-md-12"/>
      </div>
    )
  }

  marcarDesmarcarCheckboxVendaDirecionada(e) {
      if (!e.target.checked) {
        this.setState({ vendaDirecionada: false });
        this.selecionarUsuario(null)
      } else {
        this.setState({ vendaDirecionada: true })
      }
  }

  exibirOpcoesTipoVeiculo () {
    const { buscaTipoVeiculo } = this.state
    const opts = [
      { key: campoBuscaTipoVeiculo.TODOS.chave, label: 'Todos' },
      { key: campoBuscaTipoVeiculo.RODOVIARIO.chave, label: 'Rodoviário' },
      { key: campoBuscaTipoVeiculo.AQUAVIARIO.chave, label: 'Aquaviário' }
    ]
    return (
      <div className="vx-filter-row">
        <span className="vx-filter-label">Modal:</span>
        {opts.map(opt => (
          <label
            key={opt.key}
            className={`vx-filter-chip${buscaTipoVeiculo === opt.key ? ' vx-filter-chip--active' : ''}`}
          >
            <input
              type="radio"
              name="tipoVeiculoVeiculo"
              checked={buscaTipoVeiculo === opt.key}
              onChange={() => this.setState({ buscaTipoVeiculo: opt.key })}
            />
            {opt.label}
          </label>
        ))}
      </div>
    )
  }

  exibirOpcoesBuscaEmpresa () {
    if (this.props.reservasSelecionadas !== null) return ''
    const { buscaNaEmpresaSelecionada, vendaDirecionada } = this.state
    return (
      <div className="vx-filter-row">
        <span className="vx-filter-label">Empresa:</span>
        <label className={`vx-filter-chip${buscaNaEmpresaSelecionada ? ' vx-filter-chip--active' : ''}`}>
          <input
            type="radio"
            name='radioBusca'
            id='radioEmpresaSelecionada'
            onChange={() => this.setState({ buscaNaEmpresaSelecionada: true })}
            checked={buscaNaEmpresaSelecionada}
          />
          {this.props.empresaSelecionada.nome}
        </label>
        <label className={`vx-filter-chip${!buscaNaEmpresaSelecionada ? ' vx-filter-chip--active' : ''}`}>
          <input
            type="radio"
            name='radioBusca'
            id='radioTodasEmpresas'
            onChange={() => this.setState({ buscaNaEmpresaSelecionada: false })}
            checked={!buscaNaEmpresaSelecionada}
          />
          Todas as empresas
        </label>
        <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
          <label className={`vx-filter-chip${vendaDirecionada ? ' vx-filter-chip--active' : ''}`}>
            <input
              type="checkbox"
              name='radioBusca'
              id='radioVendaDirecionada'
              onChange={(e) => this.marcarDesmarcarCheckboxVendaDirecionada(e)}
              checked={vendaDirecionada}
            />
            Direcionar venda
          </label>
        </Autorizacao>
      </div>
    )
  }

  exibirOpcaoBuscaVendedor(){
    return (
    <React.Fragment>
      <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
        {this.state.vendaDirecionada === true ?
            <div className="input-group mb-3 mt-3 justify-content-end">
              <div className="col-md-6 col-sm-12">
                <SelecaoUsuarioEmpresaAutoComplete
                                          name='pesquisaUsuario'
                                          placeholder='Nome, e-mail ou código do vendedor'
                                          selecionarUsuario={this.selecionarUsuario}
                                          value={this.props.usuarioSelecionado}
                />
              </div>
            </div> : ''}
      </Autorizacao>
            </React.Fragment>)
  }

  exibirAtual () {
    if (this.state.paginaSelecionada === 1) {
      return (<div className='col-12'>
        {this.exibirCampoBusca()}
        {this.exibirOpcoesBuscaEmpresa()}
        {this.exibirOpcaoBuscaVendedor()}
        {this.exibirOpcoesTipoVeiculo()}
        {this.exibirItinerario(this.props.viagens.passagensIda, 'IDA')}
        {this.exibirItinerario(this.props.viagens.passagensRetorno, 'VOLTA')}
      </div>)
    }

    if (this.state.paginaSelecionada === 2) {
      return <AbaSelecionarEMarcarPoltrona voltar={() => this.setState({ paginaSelecionada: 1 })}/>
    }
    return '';
  }

  exibir () {
    const vendaOfflinePermitida = !this.props.online && getUsuarioHabilitadoVendaOffline(this.props.empresaSelecionada.id);
    if (this.props.caixaAberto || vendaOfflinePermitida) {
      return this.exibirAtual()
    }
    return <div className='col-12'>
      <div className="mt-2 alert alert-warning text-center" role="alert">
        Seu caixa está em análise de fechamento. Para efetuar mais vendas contate seu gerente.
      </div>
    </div>;
  }

  render () {
    return (
      <Autorizacao
        perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id), ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
        <div className="row internas">
          {this.exibir()}
        </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (

  {
    viagens: state.viagens,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    viagem: state.viagem,
    origem: state.origem,
    destino: state.destino,
    dataIda: state.dataIda,
    dataVolta: state.dataVolta,
    empresaSelecionada: state.empresaSelecionada,
    cidades: state.cidades,
    caixaAberto: state.caixaAberto,
    online: state.conexao ? state.conexao.online : true,
    reservasSelecionadas: state.remarcacao.reservasSelecionadas,
    empresas: state.authentication.empresas,
    usuarioSelecionado: state.usuarioSelecionado
  });

export default connect(mapStateToProps,
  {
    selecionarDestino,
    selecionarOrigem,
    buscarViagens,
    limparViagens,
    selecionarViagemIda,
    selecionarViagemVolta,
    selecionarDataVolta,
    selecionarDataIda,
    limparDataVolta,
    alterarViagemSelecionada,
    limparMapaVeiculoItinerarioIda,
    limparMapaVeiculoItinerarioVolta,
    adicionarFormasPagamento,
    adicionarDadosComprador,
    alterarEmpresaSelecionada,
    selecionarUsuario
  })(AbaItinerario)
